module.exports = __webpack_public_path__ + "static/img/logo_white.8db58e8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_white.svg
// module id = vVM4
// module chunks = 1